<template>
  <div>
    <sc-panel-navigator @update="updateTable">
      <el-card>
        <div slot="header" class="clearfix">
          <span style="float:left">Availabel Holiday Packages</span>

          <el-button style="float:right" @click="loadPackage('new')">
            <fa icon="plus" fixed-width></fa>
            <fa icon="cubes" fixed-width size="lg"></fa>
          </el-button>
        </div>
        <div>
          <s-table
            v-if="loaded"
            :colDefinitions="colTripDefinitions"
            modx-processor="tripservice/getlist"
            :r-query="{'daterange':( (bookingRange[0]?bookingRange[0]:'')+'-'+ (bookingRange[1]?bookingRange[1]:'')),searchall:searchall,kind: 'PACKAGE' }"
            @cell-clicked="loadPackage"
            ref="packageList"
          ></s-table>
        </div>
      </el-card>
    </sc-panel-navigator>
  </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

import printHtml from "~/mixins/printHtml";

export default {
  mixins: [printHtml],
  data() {
    return {
      printData: null,
      printReady: false,
      loaded: false,
      timelineView: false,
      page: 1,
      searchall: null,
      bookingRange: [
        dateHelper.format(dateHelper.startOfToday(), "DD/MM/YYYY"),
        dateHelper.format(dateHelper.endOfTomorrow(), "DD/MM/YYYY"),
      ],
      bookingRangeA: "",
      bookingRangeZ: "",
      cols: {},
      dateFormat: "DD/MM/YY",
    };
  },
  methods: {
    updateTable(msg) {
      _log_("hell.UPDATE..", msg);
      this.$refs.packageList.updateOrAppendRow(msg);
    },
    loadPackage(selector) {
      _log_("hell...", selector);
      const id = selector.row ? selector.row.id : selector;
      this.routeGo({
        name: "package",
        params: { packageid: id },
      });
    },
  },
  async mounted() {
    const date = new Date();
    this.bookingRange = [
      dateHelper.format(dateHelper.startOfToday(), "DD/MM/YYYY"),
      dateHelper.format(dateHelper.endOfTomorrow(), "DD/MM/YYYY"),
    ];
    //  [
    //   date.getTime(),
    //   date.getTime() + 3600 * 1000 * 24 * 91
    // ];
    _log_("bk r ..0.0..", this.bookingRange);

    this.loaded = true;
    // _log_("the rs///", this.rooms);
  },
  computed: {
    colTripDefinitions() {
      var rw = "580px",
        vm = this;
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [
        { prop: "title", width: "", label: "Package" },
        { prop: "year", width: "", label: "Date", formatterType: "unxToDate" },
      ];
    },
  },
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}
.has-more {
  color: red;
  font-weight: 700;
}
</style>
